import { gql } from 'graphql-tag'
import queryPageFields from '#layers/core/data-layer/pages/page/query-page-fields'
import { fragmentModuleChapter, fragmentModuleMedia } from '#layers/core/data-layer/modules/fragments'

export default gql`
  ${fragmentModuleChapter}
  ${fragmentModuleMedia}
  query($slug: String! = "", $sysId: String! = "", $locale: String!, $withParent: Boolean! = false, $slugParent: String! = "", $preview: Boolean! = false) {
    page: pageLicensesDetailCollection(limit: 1, where: { OR: [{ sys: { id: $sysId }}, { slug: $slug }]}, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        defaultLocaleFallbackEnabled
        introText {
          json
        }
        highlightText {
          json
        }
        downloadDocument {
          ...ModuleMediaFragment
        }
        chaptersCollection(limit: 20) {
          items {
            ...ModuleChapterFragment
          }
        }
      }
    }
    pageParent: pageLicensesCollection(limit: 1, where: { slug: $slugParent }, locale: $locale, preview: $preview) @include(if: $withParent) {
      items {
        sys {
          id
        }
        title
        itemsCollection {
          items {
             sys {
              id
            }
            navigationTitle
          }
        }
      }
    }
  }
`
